import { ApiCatch } from "@/utils/decorators";
import { Api } from "../api.service";
import { ApiTranslate } from "@/utils/decorators";

export class UsersManagementService {
  @ApiCatch
  static async getUsers(params: any) {
    const response = await Api.get("/users-management/users/", {
      params,
    });
    return response.data;
  }

  @ApiCatch
  static async getUserInfo(user_rid: string) {
    const response = await Api.get("/users-management/users/" + user_rid);
    return response.data;
  }

  @ApiCatch
  static async addUser(payload: any) {
    const response = await Api.post("/users-management/users/", payload);
    return response.data;
  }

  @ApiCatch
  static async editUser(payload: any) {
    const response = await Api.put("/users-management/users/", payload);
    return response.data;
  }

  @ApiCatch
  static async updateUserStatus(user_rid: string, active: boolean) {
    const response = await Api.put(
      `/users-management/users/${user_rid}/status`,
      { active },
    );
    return response.data;
  }

  @ApiCatch
  static async checkEmailAvailability(email: string) {
    const response = await Api.get(`/users-management/email/${email}/exists`);
    return response.data;
  }

  @ApiCatch
  static async getOrganizationContracts(org_rid: string) {
    const response = await Api.get(
      `/users-management/organizations/${org_rid}/contracts`,
    );
    return response.data;
  }

  @ApiCatch
  static async getUserContracts(user_rid: string) {
    const response = await Api.get(
      `/users-management/users/${user_rid}/contracts`,
    );
    return response.data;
  }

  @ApiCatch
  static async getUserRoles() {
    const response = await Api.get("/users-management/roles");
    return response.data;
  }

  @ApiCatch
  static async resendUserEmaiVerification(user_rid: string) {
    const response = await Api.put("/users-management/email/resend", {
      user_rid,
    });
    return response;
  }

  @ApiTranslate
  public static async verifyUserEmail(secretHash: string): Promise<{}> {
    const response = await Api.put("/users-management/email/confirm", {
      secretHash,
    });
    return {
      result: response.data,
    };
  }
}
